"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const Date_1 = __importDefault(require("helpers/Date"));
const types_1 = require("modules/content/dripping/types");
const pageCardInformation_1 = __importDefault(require("./pageCardInformation"));
const PageCardLiberation = ({ liberation, onHover }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const getLabels = () => {
        switch (liberation.type) {
            case types_1.DrippingLiberationTypes.Days:
                return {
                    content: t('general.n_days', {
                        days: liberation.liberationDays,
                        amountToPluralize: liberation.liberationDays
                    }),
                    tooltip: t('dripping_2.liberated_n_days', {
                        days: liberation.liberationDays,
                        amountToPluralize: liberation.liberationDays
                    })
                };
            case types_1.DrippingLiberationTypes.Date:
                const formattedDate = Date_1.default.formatDate(liberation.liberationDate, 'DD/MM/YYYY');
                return {
                    content: formattedDate,
                    tooltip: t('dripping_2.liberated_on', {
                        date: formattedDate
                    })
                };
            case types_1.DrippingLiberationTypes.Quiz:
                return {
                    content: t('dripping_2.quiz_approval'),
                    tooltip: t('dripping_2.liberated_quiz')
                };
            default:
                return null;
        }
    };
    const labels = getLabels();
    if (!labels) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(pageCardInformation_1.default, { icon: ['fal', 'calendar-check'], tooltip: labels.tooltip, onHover: onHover, children: labels.content }));
};
exports.default = PageCardLiberation;
